import { render, staticRenderFns } from "./header-search.vue?vue&type=template&id=631f1b7a&"
import script from "./header-search.vue?vue&type=script&lang=js&"
export * from "./header-search.vue?vue&type=script&lang=js&"
import style0 from "./header-search.vue?vue&type=style&index=0&id=631f1b7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports